import '../../node_modules/leaflet/dist/leaflet.css'
import * as L from 'leaflet'
import * as esri from 'esri-leaflet'
import wms from 'leaflet.wms'

import 'leaflet-control-geocoder/dist/Control.Geocoder.css'
import 'leaflet-control-geocoder/dist/Control.Geocoder.min.js'

import 'leaflet-mouse-position/src/L.Control.MousePosition.css'
import 'leaflet-mouse-position/src/L.Control.MousePosition'

import 'leaflet.polylinemeasure/Leaflet.PolylineMeasure.css'
import 'leaflet.polylinemeasure/Leaflet.PolylineMeasure'
/*
import '@geoman-io/leaflet-geoman-free'
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css'
*/
//import 'leaflet.browser.print/dist/leaflet.browser.print.min.js'

import 'leaflet-groupedlayercontrol/dist/leaflet.groupedlayercontrol.min.css'
import 'leaflet-groupedlayercontrol/dist/leaflet.groupedlayercontrol.min.js'

import 'leaflet-bing-layer';

import { isArray, isEmpty } from 'lodash'

//import 'leaflet.coordinates/dist/Leaflet.Coordinates-0.1.5.css'
//import 'leaflet.coordinates/dist/Leaflet.Coordinates-0.1.5.min.js'
//import 'leaflet.coordinates/dist/Leaflet.Coordinates-0.1.5.src.js'

import '../coord/Control.Coordinates.css'
import '../coord/Control.Coordinates.js'

/*export function getFeatureInfoUrl (map, layer, latlng, params) {
  let point = map.latLngToContainerPoint(latlng, map.getZoom()),
    size = map.getSize(),
    bounds = map.getBounds(),
    sw = bounds.getSouthWest(),
    ne = bounds.getNorthEast()

  // sw = crs.projection._proj.forward([sw.lng, sw.lat])
  // ne = crs.projection._proj.forward([ne.lng, ne.lat])
  sw = [sw.lng, sw.lat]
  ne = [ne.lng, ne.lat]

  let defaultParams = {
    request: 'GetFeatureInfo',
    service: 'WMS',
    // srs: layer._crs.code,
    srs: 'EPSG:4674',
    styles: '',
    // version: layer._wmsVersion,
    version: '1.1.1',
    format: layer.options.format,
    bbox: [sw.join(','), ne.join(',')].join(','),
    height: size.y,
    width: size.x,
    layers: layer.options.layers,
    query_layers: layer.options.layers,
    info_format: 'application/json',
    exceptions: 'application/json',
    feature_count: 100 // FIXME
  }

  params = L.Util.extend(defaultParams, params || {})

  params[params.version === '1.3.0' ? 'i' : 'x'] = point.x
  params[params.version === '1.3.0' ? 'j' : 'y'] = point.y

  return layer._url + L.Util.getParamString(params, layer._url, true)
}*/

export function getLegendGraphicUrl (name, size) {
  let url = new URL(process.env.VUE_APP_GEOSERVER)
  let sizeLegend = size < 600 ? 16 : 20;
  url.searchParams.append('SERVICE', 'wms')
  url.searchParams.append('REQUEST', 'GetLegendGraphic')
  url.searchParams.append('VERSION', '1.0.0')
  url.searchParams.append('FORMAT', 'image/png')
  url.searchParams.append('WIDTH', sizeLegend)
  url.searchParams.append('HEIGHT', sizeLegend)
  url.searchParams.append('LAYER', name)
  url.searchParams.append('TRANSPARENT', true)
//  url.searchParams.append('LEGEND_OPTIONS', 'fontName:DejaVu Sans;fontSize:12;fontAntiAliasing:true')
  url.searchParams.append('LEGEND_OPTIONS', 'fontAntiAliasing:true')

  return url.toString()
}

export function createLegend (map) {
  let legend = L.control({
    position: 'bottomleft'
  })

  let div           = L.DomUtil.create('div', 'leaflet-info leaflet-legend')
  let layerGroup    = []
  let legendEnable  = true

  map.on('overlayadd', (e) => {
     let name  = e.name
     let layer = e.layer._name.toString()
     layerGroup.push({name, layer})
     printLegend(name, getLegendGraphicUrl(layer, map.getSize().x), legendEnable)
  })

  map.on('overlayremove', (e) => { /* (e) */
    div.innerHTML = ''
    //let indice = layerGroup.indexOf(e.name);
    let indice = layerGroup.map(function(t) { return t.name; }).indexOf(e.name)
    while(indice >= 0){
      layerGroup.splice(indice, 1);
      indice = layerGroup.map(function(t) { return t.name; }).indexOf(e.name)
    }

    if (layerGroup.length > 0)
      printLegend(layerGroup[layerGroup.length-1].name, getLegendGraphicUrl(layerGroup[layerGroup.length-1].layer, map.getSize().x), legendEnable)     
  })

  legend.onAdd = () => { /* map */
    map.eachLayer(layer => {
      if (layer.wmsParams) {
            let InitialLayers = layer.wmsParams.layers.split(',')
              InitialLayers.forEach(layerTemp => {
                if (layerTemp === 'itcg:municipios_pol_p31982_e50')
                  layerGroup.push({name : 'Municípios do Paraná', layer : layerTemp})
                //if (layerTemp === 'emater:fonte_pto_p31982')
                //  layerGroup.push({name : 'Fontes', layer : layerTemp})
                if (layerTemp === 'emater:monitoramento_ferrugem_soja_pto_p4674')
                  layerGroup.push({name : 'Alerta Ferrugem - Safra 2023/2024', layer : layerTemp})
                printLegend(layerGroup[layerGroup.length-1].name, getLegendGraphicUrl(layerGroup[layerGroup.length-1].layer, map.getSize().x), legendEnable)
            })
      }
    })
    return div
  }

  div.onclick = function() {//uso somente em mobile
    legendEnable = legendEnable ? false : true
    printLegend(layerGroup[layerGroup.length-1].name, getLegendGraphicUrl(layerGroup[layerGroup.length-1].layer, map.getSize().x), legendEnable)
}

  function printLegend (title, layer, legendEnable) {
    div.innerHTML = legendEnable 
      ?  '<strong>' + title + '</strong> <br /> <img src="' + layer + '"><br />'
      :  '<h1 style="padding: 15px 12px; margin: 0">...</h1>'
  }
  legend.addTo(map)
  return legend
}

//function returnTemplate () {
//}

export function createMeasure (map) {
  L.control.polylineMeasure({
    measureControlTitleOn : 'Medir Distância',
    measureControlTitleOff: 'Finalizar'
  }).addTo(map)
}

export function mousePosition (map) {
  L.control.mousePosition({
    position: 'bottomright'
  }).addTo(map)
}

export function createBaseLayers (map) {
  let baseLayers = {
    'Bing Aéreo'      : L.tileLayer.bing('AuhiCJHlGzhg93IqUH_oCpl_-ZUrIE6SPftlyGYUvr9Amx5nzA-WqGcPquyFZl4L'),
    //'ESRI Imagery'    : esri.basemapLayer('Imagery'),
    'ESRI Topographic': esri.basemapLayer('Topographic'),
    'OpenStreetMap'   : L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }),
    /*'Transparente'    : L.tileLayer.wms(process.env.VUE_APP_GEOSERVER, {
        layers: 'itcg:baselayer_pr_transparente_pol_p31982_e50_a2014'
    })*/
  }

  let baseLayer = baseLayers['OpenStreetMap']
  baseLayer.addTo(map)

  return baseLayers
}

export function createGroupedOverlays (user) {
  var Source = wms.Source.extend({
    parseFeatureInfo: function (result) { //       
      var json = JSON.parse(result)
      if (json.features.length === 0) return 'Sem dados disponíveis'
      /*
      var properties = json.features[0].properties      
      var html = '<h2><center>' + json.features[0].id + '</center></h2>'
      html += '<table style="border: 2px">'
      for (var property in properties) {
        html += '<tr><td style="padding-top: 4px; padding-bottom: 4px; padding-right: 4px"><b>' + property + '</b></td>'
        html += '<td style="padding-top: 4px; padding-bottom: 4px">' + properties[property] + '</td></tr>'
      }
      html += '</table>'
      */
      return getTemplate(json.features[0])
    }
  })
  
  var source = new Source(process.env.VUE_APP_GEOSERVER, {
    format: 'image/png',
    info_format: 'application/json',
    transparent: true,
    tiled: true
  })

  var groupedOverlays =  '';
  if (user==='fontes'){
    groupedOverlays = {
      'Dados Paraná': {
        'Municípios do Paraná':     source.getLayer('itcg:municipios_pol_p31982_e50')      
      },
      'IDR/Paraná': {
        'Fontes':                   source.getLayer('emater:fonte_pto_p31982')
      }
    }
  } else if (user==='ferrugem'){
    groupedOverlays = {
      'Dados Paraná': {
        'Municípios do Paraná':     source.getLayer('itcg:municipios_pol_p31982_e50')      
      },
      'IDR/Paraná': {
        //'Ferrugem':                 source.getLayer('emater:monitoramento_ferrugem_soja_pto_p31982')
        'Alerta Ferrugem':                 source.getLayer('emater:monitoramento_ferrugem_soja_pto_p4674')
      }
    }
  } else {
    groupedOverlays = {
      'Dados Paraná': {
        'Municípios do Paraná':     source.getLayer('itcg:municipios_pol_p31982_e50')      
      },
      'IDR/Paraná': {
        'Fontes':                   source.getLayer('emater:fonte_pto_p31982'),
        'Pontos de Solo':           source.getLayer('emater:ptsolopr_pto_p4674'),
        'Microbacias Detalhadas':   source.getLayer('emater:microbacias_pol_p4674'),
        'Ottobacias (IDR-Paraná)':  source.getLayer('emater:ottobacias_pol_p29192'),
        'Rios PR':                  source.getLayer('emater:prrios_lin_p4674'),
        'Amora':                    source.getLayer('emater:amora_pol_p31982'),
        'Tanques Psicultura':       source.getLayer('emater:tanques_piscicultura_pol_p31982'),
        'Classes de Solo':          source.getLayer('emater:classes_solos_pol_p29192')
      }
    }
  }

  return groupedOverlays
}

function getTemplate (json) {
  let properties = json.properties
  let id = json.id
  if (id.includes('fonte_pto_p31982')){
    id = 'Fontes'
  } else if (id.includes('ptsolopr_pto_p4674')) {
    id = 'Pontos de Solo'
  } else if (id.includes('microbacias_pol_p4674')) {
    id = 'Microbacias Detalhadas'
  } else if (id.includes('ottobacias_pol_p29192')) {
    id = 'Ottobacias (IDR-Paraná)'
  } else if (id.includes('prrios_lin_p4674')) {
    id = 'Rios PR'
  } else if (id.includes('amora_pol_p31982')) {
    id = 'Amora'
  } else if (id.includes('tanques_piscicultura_pol_p31982')) {
    id = 'Tanques Psicultura'
  } else if (id.includes('classes_solos_pol_p29192')) {
    id = 'Classes de Solo'
  } else if (id.includes('monitoramento_ferrugem_soja_pto_p31982')){
    id = 'Alerta Ferrugem'
  }
  let html = '<h2><center>' + id + '</center></h2>'
  html += '<table style="border: 2px">'
  for (let property in properties) {
    console.log("propriedades: " + properties[property]);
    html += '<tr><td style="padding-top: 4px; padding-bottom: 4px; padding-right: 4px"><b>' + property + '</b></td>'
    html += '<td style="padding-top: 4px; padding-bottom: 4px">' + properties[property] + '</td></tr>'
  }
  html += '</table>'
  return html
}

// WFS Contorno do Paraná
/*
export function getExtent () {
  axios.get(process.env.VUE_APP_GEOSERVER, {
    params: {
      service: 'wfs',
      version: '2.0.0',
      outputFormat: 'application/json',
      exceptions: 'application/json',
      request: 'GetFeature',
      typeNames: 'itcg:contorno_pr_pol_p31982_e50_a2014',
      srsName: 'EPSG:4674'
    }
  })
    .then(response => {
      console.log('getExtent')
      console.log(L.geoJson(response.data).getBounds())
    })
}
*/

export function getBounds () {
  let ne = L.latLng(-22.51664754, -48.02383566),
    sw = L.latLng(-26.71623274, -54.61930655),
    bounds = L.latLngBounds(ne, sw)

  return bounds
}

//export function browserPrint () {
//  return L.control.browserPrint()
//}

/**
 * Converts an Object to ViewParams String.
 * @author Andre Huller <ahuller@celepar.pr.gov.br>
 * @param {Object} viewParams
 * @returns {string}
 */
export function toViewParams (viewParams) {
  //  FIXME: i --> name
  let params = []

  for (var i in viewParams) {
    let value = null

    if (isArray(viewParams[i])) {
      if (!isEmpty(viewParams[i])) {
        if (isNaN(viewParams[i][0])) {
          value = viewParams[i].map((param) => "'" + param + "'").join('\\,')
        } else {
          value = viewParams[i].join('\\,') // FIXME ??
        }
      }
    } else if (viewParams[i]) {
      value = viewParams[i]
    }

    if (value) {
      params.push([i, value].join(':'))
    }
  }

  return params.join(';')
}

/* Custom Controls */
/**
 * Creates the GetFeatureInfo Control
 * @author Andre Huller <ahuller@celepar.pr.gov.br>
 */
/*
export function getFeatureInfo (map, layer) {
  L.Control.GetFeatureInfo = L.Control.extend({
    options: {
      position: 'topleft',
      text: 'Informações',
      title: 'Informações',
      className: 'leaflet-control-getfeatureinfo',
      enabled: false
    },
    onAdd: function (map) {
      this._map = map
      var container = L.DomUtil.create('div', 'leaflet-bar '
        + this.options.className)

      var link = L.DomUtil.create('a', this.options.className + '-toggle', container)
      link.href = "#"
      link.title = this.options.title

      L.DomEvent
        .on(link, 'mousedown dblclick', L.DomEvent.stopPropagation)
        .on(link, 'click', L.DomEvent.stop)
        .on(link, 'click', this._toggleGetFeatureInfo, this)

      this._anchor = link
      return container
    },
    onRemove: function () {
      // ..
    },
    _toggleGetFeatureInfo: function () {
      this.options.enabled = !this.options.enabled
      if (this.options.enabled) {
        this._map.on('click', this._getFeatureInfo, this)
        this._anchor.classList.add('leaflet-control-active')
      } else {
        this._map.off('click', this._getFeatureInfo, this)
        this._anchor.classList.remove('leaflet-control-active')
      }
    },
    _getFeatureInfo: function (e) {
      var url = getFeatureInfoUrl(this._map, layer, e.latlng)

      var template = `
        <h2>{nome}</h2>
        <p><strong>Código IBGE</strong>: {codibge}</p>
        <p><strong>Dirigente Municipal</strong>: {dirigentemunicipal}</p>
        <p><strong>E-mail Dirigente Municipal</strong>: {email}</p>
        <p><strong>População</strong>: {pop2010}</p>
        <p><strong>IDHM (2000)</strong>: {idhm_2000}</p>
      `

      axios.get(url)
        .then(response => {
          console.log(response.data)
          var feature = response.data.features[0]

          if (feature) {
            L.popup()
              .setLatLng(e.latlng)
              .setContent(L.Util.template(template, feature.properties))
              .openOn(this._map)
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  })

  return new L.Control.GetFeatureInfo(map)
}
*/

export function homeExtent (map) {
  L.Control.HomeExtent = L.Control.extend({
    options: {
      position: 'topleft',
      text: 'Visão Inicial',
      title: 'Visão Inicial',
      className: 'leaflet-control-homeextent'
    },
    onAdd: function (map) {
      this._map = map
      var container = L.DomUtil.create('div', 'leaflet-bar '
        + this.options.className)

      // this._container = container

      var link = L.DomUtil.create('a', this.options.className + '-toggle', container)
      link.href = "#"
      // link.innerHTML = this.options.text
      link.title = this.options.title

      L.DomEvent
        .on(link, 'mousedown dblclick', L.DomEvent.stopPropagation)
        .on(link, 'click', L.DomEvent.stop)
        .on(link, 'click', this._fitBounds, this)

      return container
    },
    onRemove: function () {
      // ..
    },
    _fitBounds: function () {
      this._map.fitBounds(getBounds())
    }
  })

  return new L.Control.HomeExtent(map)
}

export function coordExtent (map) {
  L.Control.CoordExtent = L.Control.extend({
    options: {
      position: 'topleft',
      text: 'Digitar Coordenadas',
      title: 'Digitar Coordenadas',
      className: 'leaflet-control-coordextent'
    },
    onAdd: function (map) {
      this._map = map
      var container = L.DomUtil.create('div', 'leaflet-bar ' + this.options.className)

      // this._container = container

      var link = L.DomUtil.create('a', this.options.className + '-toggle', container)
      link.href = "#"
      // link.innerHTML = this.options.text
      link.title = this.options.title

      L.DomEvent
        .on(link, 'mousedown dblclick', L.DomEvent.stopPropagation)
        .on(link, 'click', L.DomEvent.stop)
        .on(link, 'click', this._fitBounds, this)

      return container
    },
    onRemove: function () {
      // ..
    },
    _fitBounds: function () {
      this._map.fitBounds(getBounds())
    }
  })

  return new L.Control.CoordExtent(map)
}

export function watermark () {
  L.Control.Watermark = L.Control.extend({
    onAdd: function () { /* map */
      let img = L.DomUtil.create('img')
      img.src = require('@/assets/logo.png')
      img.style.width = '200px'

      return img
    },
    onRemove: function () { /* map */
      // Nothing to do here
    }
  })

  L.control.watermark = function (opts) {
    return new L.Control.Watermark(opts)
  }

  return L.control.watermark({
    position: 'bottomleft'
  })
}

export function coordinates (map, dms) {
  let lat = dms ? "S {y}" : "Lat: {y}";
  let lon = dms ? "O {x}" : "Lng: {x}";
  L.control.coordinates({
//position:"bottomright", //optional default "bootomright"
    decimals:4,
    decimalSeperator:",",
    labelTemplateLat: lat,
    labelTemplateLng: lon,
    useLatLngOrder: true,
    centerUserCoordinates: true,
    useDMS: dms,
		enableUserInput: true
  }).addTo(map);

/*  L.control.bottomright({
    position:"topright",
    useDMS:true,
    labelTemplateLat:"N {y}",
    labelTemplateLng:"L {x}",
    useLatLngOrder:true
  }).addTo(map);
*/
}
